import React from "react";
import styled from "styled-components";
import { Select } from "antd";
import type { SelectProps } from "antd";

type StyledSelectProps = SelectProps<string>;

const BaseSelect: React.FC<StyledSelectProps> = (props) => <Select<string> {...props} />;

export const StyledSelect = styled(BaseSelect)`
	&& .ant-select-selector {
		border: 1px solid #cdd4f6 !important;
		border-radius: 8px !important;
		padding: 2px 12px !important;
		display: flex !important;
		box-shadow: none !important;
		height: auto !important;
		align-items: center !important;
		height: 28px !important;
	}

	&& .ant-select-arrow,
	&& .ant-select-clear {
		color: #333 !important;
		align-items: center !important;
		justify-content: center !important;
		margin-top: -4px !important;
	}

	&& .ant-select-selection-item,
	&& .ant-select-selection-placeholder {
		font-size: 14px;
		line-height: 24px !important;
		height: 24px !important;
	}

	&& .ant-select-selection-search-input {
		font-size: 14px;
	}

	&&:hover .ant-select-selector {
		border-color: #8193f1 !important;
	}

	&&.ant-select-focused .ant-select-selector,
	&&.ant-select-open .ant-select-selector {
		border: 1px solid #8193f1 !important;
		box-shadow: 0px 4px 12px 0px #1559a51f !important;
	}
`;
